import AxiosInstance from "./api";

export const JournalVoucher9Service = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/journal-voucher-9s/paginate", {
      params: query,
    });
  },

  getById: async (id) => {
    return await AxiosInstance.get("/private/journal-voucher-9s/" + id);
  },

  create: async (payload) => {
    return await AxiosInstance.post("/private/journal-voucher-9s", payload);
  },

  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/journal-voucher-9s/" + id, payload);
  },

  delete: async (id) => {
    return await AxiosInstance.delete("/private/journal-voucher-9s/" + id);
  },

  preview: async (params) => {
    return await AxiosInstance.get("/private/journal-voucher-9s/preview", {
      params,
    });
  },

  sync: async (params) => {
    return await AxiosInstance.post("/private/journal-voucher-9s/sync", null, {
      params,
    });
  },
};
